import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider, theme } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

// 深色主题配色方案
const darkTheme = {
  token: {
    // 主色调 - 青绿色
    colorPrimary: '#00d4aa',
    colorPrimaryHover: '#00e6b8',
    colorPrimaryActive: '#00c299',
    
    // 背景色
    colorBgBase: '#0d0d12',
    colorBgContainer: '#1a1a24',
    colorBgElevated: '#252532',
    colorBgLayout: '#0d0d12',
    
    // 文字颜色
    colorText: '#e8e8ec',
    colorTextSecondary: '#a0a0b0',
    colorTextTertiary: '#6c6c7d',
    
    // 边框颜色
    colorBorder: '#2a2a3a',
    colorBorderSecondary: '#353545',
    
    // 其他
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#00d4aa',
    
    // 圆角
    borderRadius: 8,
    borderRadiusSM: 4,
    borderRadiusLG: 12,
    
    // 阴影
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)',
    boxShadowSecondary: '0 8px 24px rgba(0, 0, 0, 0.6)',
  },
  components: {
    Layout: {
      headerBg: '#15151c',
      headerColor: '#e8e8ec',
      bodyBg: '#0d0d12',
      siderBg: '#15151c',
    },
    Card: {
      colorBgContainer: '#1a1a24',
      colorBorderSecondary: '#2a2a3a',
    },
    Button: {
      colorBgContainer: '#252532',
      colorBorder: '#00d4aa',
    },
    Table: {
      colorBgContainer: '#1a1a24',
      headerBg: '#252532',
      headerColor: '#e8e8ec',
    },
    Modal: {
      contentBg: '#1a1a24',
      headerBg: '#1a1a24',
    },
    Input: {
      colorBgContainer: '#252532',
      colorBorder: '#2a2a3a',
    },
    Select: {
      colorBgContainer: '#252532',
      colorBorder: '#2a2a3a',
    },
    Menu: {
      colorBgContainer: '#15151c',
      colorItemBgSelected: '#00d4aa22',
      colorItemTextSelected: '#00d4aa',
    },
    Steps: {
      colorText: '#a0a0b0',
      colorTextDescription: '#6c6c7d',
    },
    Tag: {
      colorBgContainer: '#252532',
    },
    Divider: {
      colorSplit: '#2a2a3a',
    },
  },
  algorithm: theme.darkAlgorithm,
};

root.render(
  <React.StrictMode>
    <ConfigProvider locale={zhCN} theme={darkTheme}>
      <App />
    </ConfigProvider>
  </React.StrictMode>
);
